module.exports = __webpack_public_path__ + "img/alabama-forestry-logo.ec209d5c.jpg";